module.exports = __webpack_public_path__ + "static/media/spicy-dumplings-uncropped.f2622865.png";